import React from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import shoppingCartActions from "../../../store/actions/shoppingCart/shoppingCart.actions";

import "../../../styles/components/items/itemCardShoppingCartActionsComponent.scss";

export const ItemCardShoppingCartActionsComponent = ({ props, shoppingCartActions }) => {
  const { product, style = {} } = props;
  const itemPackSize = product.minOrderQuantity <= 1 ? 1 : product.minOrderQuantity;

  // Get the current quantity from the shopping cart state
  const cartItem = useSelector((state) => state.shoppingCart.shoppingCartItems.find((item) => item.id === product.id));
  const cartQuantity = cartItem?.quantity || 0;

  // Map product to shoppingCartItem structure
  const mapToShoppingCartItem = (product) => ({
    id: product.id,
    itemId: product.itemId,
    itemDescription: product.itemDescription,
    salePriceInNIS: product.salePriceInNIS,
    quantity: itemPackSize,
    itemPackSize: itemPackSize,
    pictureUrl: product.pictureUrl,
  });

  // Handlers for adding and removing items
  const handleAddToCart = () => {
    if (!product.isAvailable) return;
    shoppingCartActions.addToCart(mapToShoppingCartItem(product));
  };

  const handleRemoveFromCart = () => {
    if (!product.isAvailable) return;
    if (cartQuantity > itemPackSize) {
      shoppingCartActions.updateCartItem({ id: product.id, quantity: cartQuantity - itemPackSize });
    } else {
      shoppingCartActions.removeFromCart(product.id);
    }
  };

  return (
    <div className="addOrRemoveFromShoppingCartContainer" style={style}>
      <button onClick={handleAddToCart} className={`${product.isAvailable ? "" : "unAvalable"}`}>
        +
      </button>
      <div>{cartQuantity}</div>
      <button onClick={handleRemoveFromCart} disabled={cartQuantity === 0} className={`${product.isAvailable ? "" : "unAvalable"}`}>
        -
      </button>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  shoppingCartActions: bindActionCreators(shoppingCartActions, dispatch),
});

export default connect(null, mapDispatchToProps)(ItemCardShoppingCartActionsComponent);
